export default __webpack_public_path__ + "static/media/internet0.76ab7af1.svg";